<template>
	<link-select v-model="model.value"
				 class="link-lov-select"
				 :class="{'link-long-component':long}"
				 :data="lovs"
				 val-key="val"
				 label-key="name"
				 :height="selectHeight"
				 :filterable="filterable"
				 :multiple="multiple"

				 :beforeSelect="pl_beforeSelect"
				 :afterSelect="afterSelect"

				 :type="type"
				 :color="color"
				 :size="size"
				 :shape="shape"
				 :dashed="dashed"
				 :long="long"
				 :placeholder="placeholder"
				 :width="width"
				 :prefixIcon="prefixIcon"
				 :suffixIcon="suffixIcon"

				 :disabled="lv_disabled"
				 :readonly="lv_readonly"
				 :hide-clear-icon="hideClearIcon"
				 :required="required"
				 :validate-on-init="validateOnInit"
				 :rules="rules"
	>
		<div slot-scope="{item,index}">
			<span>{{item.name}}</span>
		</div>
	</link-select>
</template>

<script>
	import {EditMixin} from "../mixins";

	export default {
		name: "link-lov-select",
		mixins: [EditMixin],
		props: {
			lovType: {type: String | null, required: true},
			parentLovType: {type: String},                                  //父值列表类型
			parentLovValue: {type: String},                                 //父值列表值
			parentValidMessage: {type: String, default: () => LinkVue.$t('LinkForm.pleaseSelectParentLov')},//父值列表类型存在，父值列表值为空时，提示信息
			excludeLov: {type: Array},                                      //排除的值列表
			disabledAutoSetDefault: {type: Boolean},                        //禁止自动设置默认值

			value: {},
			beforeSelect: {type: Function},
			afterSelect: {type: Function},
			filterable: {type: Boolean, default: true},
			multiple: {type: Boolean},

			type: {type: String, default: 'line',},
			color: {type: String, default: 'info',},
			size: {type: String, default: 'default',},
			shape: {type: String, default: 'none',},
			dashed: {type: Boolean,},
			long: {type: Boolean,},
			placeholder: {type: String, default: () => LinkVue.$t('LinkForm.selectPlaceholder')},
			width: {type: Number},
			hideClearIcon: {type: Boolean},
			prefixIcon: {},
			suffixIcon: {},
			selectHeight: {type: Number, default: 150},

			required: {type: Boolean},
			rules: {type: Array | String},
			validateOnInit: {type: Boolean,},
		},
		watch: {
			lovType() {
				this.reset()
			},
			parentLovType() {
				this.reset()
			},
			parentLovValue() {
				this.lv_timer = setTimeout(() => {
					this.model.value = null
					this.lv_timer = null
				}, 0)
				this.reset()
			},
		},
		data() {
			const that = this
			const model = {
				p_value: this.value,
				get value() {return this.p_value},
				set value(val) {
					if (this.p_value == val) {return}
					this.p_value = val
					that.$emit('input', val)
					that.$emit('change', val)
				}
			}
			this.$watch(() => this.value, async val => {
				await this.$lv.nextTick()// 这里执行要比 parentLovValue晚，不然手动修改formData的值的时候可能会自动清空model.value
				model.p_value = val
				if (!!this.lv_timer) {
					clearTimeout(this.lv_timer)
					this.lv_timer = null
				}
			})
			return {
				model,
				lovName: null,
				lovs: []
			}
		},
		async created() {
			this.reset()
		},
		methods: {
			async reset() {
				if (!this.lovType) return
				const {lovs, defaultVal} = await this.$lov.getLovData(this.lovType, this.parentLovType, this.parentLovValue, this.excludeLov, this.multiple)
				this.lovs = lovs || []
				// console.log('reset', this.lovType, this.lovs)
				if (!this.disabledAutoSetDefault && !this.model.value && !!defaultVal) this.model.value = defaultVal
			},
			async pl_beforeSelect() {
				if (!!this.parentLovType && this.parentLovValue == null) {
					this.$dialog.show(this.parentValidMessage)
					return Promise.reject(this.parentValidMessage)
				} else {
					!!this.beforeSelect && (await this.beforeSelect(this.model.value))
				}
			},
		}
	}
</script>

<style lang="scss">
	.link-lov-select {
		box-sizing: border-box;
	}
</style>
